


















































import { Component, Emit, Mixins, Prop, VModel } from 'vue-property-decorator'

import { SelectOptionData } from '../Pi/types'
import FlowsTemplatesMixin from './FlowsTemplatesMixin'
import AboutStep from './steps/AboutStep.vue'
import SelectTemplateStep from './steps/SelectTemplateStep.vue'
import SelectedTemplateStep from './steps/SelectedTemplateStep.vue'
import { ActiveBotLicenseSteps } from './types'

@Component({
  components: {
    SelectedTemplateStep,
    SelectTemplateStep,
    AboutStep
  },
  data() {
    return {
      ActiveBotLicenseSteps
    }
  }
})
export default class LicenseWizard extends Mixins<FlowsTemplatesMixin>(FlowsTemplatesMixin) {
  @VModel() wizardOpen!:boolean

  @Prop() targetOptions!: Array<SelectOptionData>

  @Prop() boardKey!:string

  @Emit()
  onComplete() {
    return {
      board_key: this.boardKey,
      template: this.selectedTemplate?.config
    }
  }

  afterClose() {
    this.resetWizard()
    this.wizardOpen = false
  }

  handleUpdateStep(step: ActiveBotLicenseSteps | null) {
    if (step === null) this.wizardOpen = false
    else this.updateStep(step)
  }

}
